module.exports = __webpack_public_path__ + "src/img/artist/work06_3.jpg?064b0a8e6396cd3d40b389a486aa88e5";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work06_3.jpg
// module id = 158
// module chunks = 0